import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { fetchInterestRatesAction } from '../../../actions/InterestRatesAction';
import OIMODAL from '../../../components/Modals/OI Modal';
import VolumeModal from '../../../components/Modals/VolumeModal';
import CustomDataTable from '../../../components/CustomDataTable';
import { HOMEPAGE_OPEN_INTEREST_COLUMNS } from '../../../constants/homePageConstants';
import InterestChangeFilterBar from '../InterestChangeFilterBar';
import styles from '../../Stock/stockStyles'

/** @type {React.FC<import('../../../typings').IInterestRatesTableProps>} */
const InterestRatesTable = ({ pageState, setPageState }) => {
  const history = useHistory();

  const {
    selectedResultCallValue,
    selectedGroupCallValue,
    toggleRemoveWeeksTable2,
    currentDate,
  } = pageState;
  const dispatch = useDispatch();
  /** @type {import('../../../typings').IStateReducerState} */
  const {
    isMobile,
    accessLevel,
    homeSecondTable,
    secondLoading,
    weekendErrorsBox2,
  } = useSelector((state) => state.appReducer);

  const [tableModal, setTableModal] = useState({
    OIModal: false,
    showModal: false,
    modalRowData: [],
  });

  useEffect(() => {
    dispatch(fetchInterestRatesAction(pageState));
  }, [
    selectedResultCallValue,
    selectedGroupCallValue,
    toggleRemoveWeeksTable2,
    currentDate,
  ]);

  const rowClickHandler = (row, keyName) => {
    if (keyName === 'volume')
      setTableModal((prev) => ({
        ...prev,
        modalRowData: row,
        showModal: true,
      }));
    if (keyName === 'open_int')
      setTableModal((prev) => ({ ...prev, modalRowData: row, OIModal: true }));
    if (keyName === 'expiry') {
      localStorage.setItem('SYMBOL', row.usymbol);
      history.push(`/optionschain/${row.usymbol}`);
    }
    if (keyName === 'usymbol') {
      localStorage.setItem('SYMBOL', row.usymbol);
      history.push(`/stocks/${row.usymbol}`);
    }
    if (keyName === 'size') {
      let puttCallSplit = row.option.split('');
      let puttCallvalue = puttCallSplit[0];
      const objectToSend = {
        usymbol: row.symbol,
        expiry: row.expiry,
        ivol: row.ivol,
        ivolchg: row.ivol_chg,
        asize: row.asize,
        ask: row.ask,
        bid: row.bid,
        bsize: row.bsize,
        open_int: row.open_int,
        option: row.option,
        price: row.price,
        volume: row.size,
        strike: row.strike,
        put_call: puttCallvalue,
      };
      setTableModal((prev) => ({
        ...prev,
        modalRowData: objectToSend,
        showModal: true,
      }));
    }
  };

  return (
    <div>

      <InterestChangeFilterBar
        pageState={pageState}
        setPageState={setPageState}
      />

      {tableModal.OIModal && (
        <OIMODAL
          accessLevel={accessLevel}
          isMobile={isMobile}
          showModal={tableModal.OIModal}
          ticker={tableModal.modalRowData.usymbol}
          expiration={tableModal.modalRowData.expiry}
          modalRowData={tableModal.modalRowData}
          closeOIModal={() =>
            setTableModal((prev) => ({ ...prev, OIModal: false }))
          }
          selectedDate={pageState.currentDate}
        />
      )}
      {tableModal.showModal && (
        <VolumeModal
          accessLevel={accessLevel}
          isMobile={isMobile}
          showModal={tableModal.showModal}
          modalRowData={tableModal.modalRowData}
          ticker={tableModal.modalRowData.usymbol}
          expiration={tableModal.modalRowData.expiry}
          modalDate={pageState.currentDate}
          selectedDate={pageState.currentDate}
          closeVolumeModal={() =>
            setTableModal((prev) => ({ ...prev, showModal: false }))
          }
        />
      )}
      {isMobile && pageState.toggleTable2Dropdown === false ? (
        ''
      ) : (
        <div style={isMobile ? styles.boardModalTableContainerMobile : { ...styles.boardModalTableContainer,width:'98%' }}>
          <CustomDataTable
            columns={HOMEPAGE_OPEN_INTEREST_COLUMNS}
            rows={homeSecondTable}
            loading={secondLoading}
            clickHanlder={rowClickHandler}
            error={weekendErrorsBox2}
          />
        </div>
      )}
    </div>
  );
};

export default InterestRatesTable;



// WEBPACK FOOTER //
// ./src/Pages/HomePage/Tables/InterestRatesTable.jsx